import type { DomainSchema, PdfCardDef } from '../types';
import { dateRange, esc } from '../pdf-helpers';

export const EDUCATION = {
  priority: true,
  cardTitle: '{degreeName} at {schoolName}',
  fields: {
    schoolName: { type: 'text', label: 'School' },
    degreeName: { type: 'text', label: 'Degree' },
    fieldOfStudy: { type: 'text', label: 'Field of Study' },
    startDate: { type: 'date', label: 'Start Date' },
    endDate: { type: 'date', label: 'End Date' },
    grade: { type: 'text' },
    activities: { type: 'textarea' },
    notes: { type: 'textarea' },
  },
  layout: [
    [{ field: 'degreeName' }, { field: 'schoolName' }],
    [{ field: 'fieldOfStudy' }],
    [
      { field: 'startDate', width: 50 },
      { field: 'endDate', width: 50 },
    ],
    [{ field: 'grade' }],
    [{ field: 'activities' }],
    [{ field: 'notes' }],
  ],
} satisfies DomainSchema;

export const EducationPdfCard: PdfCardDef = {
  styles: `
    .edu-item { padding: 0.8rem 0; border-bottom: 1px solid var(--line); }
    .edu-item:first-child { padding-top: 0; }
    .edu-item:last-child { border-bottom: none; padding-bottom: 0; }
    .edu-degree { font-size: 13.5px; font-weight: 700; }
    .edu-school { font-size: 11.5px; color: var(--primary); font-weight: 400; margin-top: 2px; }
    .edu-field { font-size: 11px; color: var(--body); font-weight: 300; margin-top: 1px; }
    .edu-meta { font-size: 11px; color: var(--muted); margin-top: 3px; }
  `,
  render(records) {
    return records
      .map(r => {
        const dr = dateRange(r['startDate'], r['endDate'], false);
        return `
          <div class="edu-item">
            <div class="edu-degree">${esc(r['degreeName']) || '\u2014'}</div>
            <div class="edu-school">${esc(r['schoolName'])}</div>
            ${r['fieldOfStudy'] ? `<div class="edu-field">${esc(r['fieldOfStudy'])}</div>` : ''}
            ${dr ? `<div class="edu-meta">${dr}</div>` : ''}
            ${r['grade'] ? `<span class="bp-grade">${esc(r['grade'])}</span>` : ''}
            ${r['notes'] ? `<div class="bp-note">${esc(r['notes'])}</div>` : ''}
          </div>`;
      })
      .join('');
  },
};
